export const environment = {
  production: true,
  apiUrl: 'https://2eh36uis4incegzuwvmg3a3eii0xkfzd.lambda-url.us-east-1.on.aws/',
  geoApi: '',
  mapEndpoint: 'https://maps.googleapis.com/maps/api/js',
  // mapKey: 'AIzaSyBxbjK-hWHC35NMJGTvvXV5L8BWMVivItg',
  mapKey: 'AIzaSyDzxpkF9O5vDBoMXJGpv6p508siVF3wYCk',
  urlImages: 'https://efaysto-prod-20241229194941767600000001.s3.us-east-1.amazonaws.com/',
  efaystoWallet: '0xef36b9b69F1F57b82474CB59926D2af71cdc547D',
  efaystoContactName: 'EFAYSTO' ,
  RWA_CONTRACT: '0xd17a7794F8741E3570B9E3dC886a4A0C54A260Af',
  gaMeasurementId: 'G-ZGM4GCQNP1',
  metaPixelId: '1424757866096600'
};
